import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";

import { Modal, ModalBody } from "reactstrap";
import crossIcon from "../../../../../../assets/images/cross.svg";
import Text from "components/Text";
import styles from "../styles.module.scss";
import "../styles.scss";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";

function RolesModal({
  t,
  isRolesModalOpen,
  setIsRolesModalOpen,
  designationIds,
  setDesignationIds,
  userRoles,
}) {
  const [selectedDesignation, setSelectedDesignation] = useState([
    ...designationIds,
  ]);

  // FIX: Properly toggle individual designation
  const checkDesignation = (designation) => {
    setSelectedDesignation((prev) => {
      const index = prev.findIndex(
        (item) => item.designationsId === designation.id
      );

      if (index > -1) {
        // Already selected - remove it
        return prev.filter((item) => item.designationsId !== designation.id);
      } else {
        // Not selected - add it
        return [
          ...prev,
          {
            id: 0,
            designationsId: designation.id,
            name: designation.name, // Store the name for display
          },
        ];
      }
    });
  };

  const checkMemberRoleAvaliable = (array, value) => {
    return array?.some((e) => e?.designationsId === value?.id);
  };

  const allValues = useMemo(
    () =>
      userRoles?.reduce((prev, element) => {
        element.designations.forEach(() => {
          prev += 1;
        });
        return prev;
      }, 0),
    [userRoles]
  );

  const selectAll = useMemo(
    () => allValues > 0 && selectedDesignation?.length === allValues,
    [allValues, selectedDesignation]
  );

  const handleAllChange = (e) => {
    const checked = e.target.checked;
    const values = [];

    if (checked) {
      userRoles.forEach((element) => {
        element.designations.forEach((val) => {
          // Check if already exists in designationIds
          const existing = designationIds.find(
            (item) => item.designationsId === val.id
          );

          values.push({
            id: existing?.id || 0,
            designationsId: val.id,
            name: val.name, // Store the name
          });
        });
      });
    } else {
      // Keep only items that have an id (already saved in database)
      designationIds.forEach((res) => {
        if (res.id) {
          values.push({ ...res });
        }
      });
    }
    setSelectedDesignation(values);
  };

  return (
    <Modal
      isOpen={isRolesModalOpen}
      toggle={() => setIsRolesModalOpen(false)}
      className={"modal-dialog-centered " + styles["add-roles-modal-dialog"]}
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => setIsRolesModalOpen(false)}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          <span className="modal-title-25">{t("accountOwner.addRoles")}</span>
        </Text>

        <Text
          size="12px"
          marginBottom="10px"
          weight="400"
          color="rgb(111, 119, 136)"
        >
          {selectedDesignation?.length} {t("Selected")}
        </Text>

        {userRoles?.length > 0 && (
          <div className="ch-checkbox c-field all-event-checkbox m-0">
            <label>
              <input
                type="checkbox"
                onChange={handleAllChange}
                checked={selectAll}
              />
              <span>{t("staff.selectAll")}</span>
            </label>
          </div>
        )}

        <Accordion
          className={["add-role-accordion contract-detail-accordion"]}
          preExpanded={[0]}
        >
          {userRoles.length > 0 &&
            userRoles.map((item, index) => (
              <AccordionItem uuid={index} key={item.id}>
                <AccordionItemHeading>
                  <AccordionItemButton>{item.name}</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <ul className={styles["roles-list"]}>
                    {item.designations.map((val) => (
                      <li key={val.id}>
                        <div className="ch-checkbox">
                          <label>
                            <input
                              type="checkbox"
                              checked={checkMemberRoleAvaliable(
                                selectedDesignation,
                                val
                              )}
                              onChange={() => checkDesignation(val)}
                            />
                            <span> {val.name}</span>
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </AccordionItemPanel>
              </AccordionItem>
            ))}
        </Accordion>

        <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100"
          title={t("accountOwner.addRoles")}
          onClick={() => {
            setDesignationIds(selectedDesignation);
            setIsRolesModalOpen(false);
          }}
        >
          {t("accountOwner.addRoles")}
        </button>
        <button
          className="button btn-mobile-link button-round button-border button-dark "
          onClick={() => setIsRolesModalOpen(false)}
          title={t("cancel")}
        >
          {t("cancel")}
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(RolesModal);
